import React from 'react';
import styles from './footer.module.scss';

const Footer = () => {
  return (
    <div id="footer" className={styles.container}>
      <p>©2024 DREAM LABS</p>
      <p>HELLO@DREAMLABS.WORK</p>
    </div>
  );
};

export default Footer;
